<h1 class="mb-2">
    <mdb-icon fas icon="tasks"></mdb-icon> Redepósito Cheque
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
    <!--Card content-->
    <div class="card-body d-sm-flex p-1 justify-content-between">
        <p class="mb-0">
            <span class="grey-text">Finanzas</span>
            <span> /</span>
            <span>Redepósito</span>
        </p>
    </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<app-cheques-redeposito-cabecera (onSearch)="onSearch($event)" (onSearchAll)="onSearchAll()">
</app-cheques-redeposito-cabecera>

<app-cheques-redeposito-detalles></app-cheques-redeposito-detalles>